import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { api } from '../api/client.js';
import { errorMessage } from '../errors.js';
import { toLanguage } from '../i18n.js';
import { Button, Notice } from './ui.js';

/** Saves the open problems of a site as a CSV file for Excel (T-43, every plan). */
export function CsvButton({ siteId, host }: { siteId: string; host: string }) {
  const { t, i18n } = useTranslation();
  const download = useMutation({
    mutationFn: async () => {
      const { data, error } = await api.GET('/sites/{siteId}/findings.csv', {
        params: { path: { siteId }, query: { locale: toLanguage(i18n.language) } },
        parseAs: 'blob',
      });
      if (error || !(data instanceof Blob)) throw error ?? new Error('download');
      const url = URL.createObjectURL(data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `website-guard-${host}-${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.append(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },
  });
  return (
    <>
      <Button variant="secondary" busy={download.isPending} onClick={() => download.mutate()}>
        {t('report.csv')}
      </Button>
      {download.isError ? <Notice kind="error">{errorMessage(download.error, t)}</Notice> : null}
    </>
  );
}
